import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Phase 6.AI.3 — Embed BUILD_PHASE in the bundle so the browser can
// prove to the operator "I am running THIS version of the JS code".
// This must be a hardcoded string baked into the bundle (not from
// the environment) so it survives any caching and is uniquely tied to
// the deployed artifact. Bump this on every shipped frontend fix.
//
// Operators verify by:
//   1. Opening the deployed page
//   2. Running `window.__STOCKAILY_BUILD_PHASE__` in DevTools console
//   3. Comparing it to the build_phase field returned by /api/_health/identity
// If they don't match, the browser is serving a stale bundle (CDN cache,
// service worker, or simply a stale tab) and the fix is "hard refresh".
export const FRONTEND_BUILD_PHASE = "6.BE — Valuation consistency guard + canonical provenance";
if (typeof window !== "undefined") {
  window.__STOCKAILY_BUILD_PHASE__ = FRONTEND_BUILD_PHASE;
  // Log once on load so operators can see it in the console without
  // having to dig — instantly answers "is the browser running the
  // new code?" without any tooling.
  // eslint-disable-next-line no-console
  console.info("[Stockaily] frontend build:", FRONTEND_BUILD_PHASE);
}

// Ensure dark mode on root before paint to avoid flash
if (typeof document !== "undefined") {
  document.documentElement.classList.add("dark");
  document.documentElement.style.colorScheme = "dark";
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
